// extracted by mini-css-extract-plugin
module.exports = {"container":"_g7rVJnd","isSingle":"Y1bpdQ9M","styledChartAreaWrapper":"_m_RtKxX","header":"pCZQFjIH","snake":"EKUb7mR_","skeletonChartLoaderWrapper":"YizX5dNN"};